import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from 'Components/Base/Icon'

const CheckboxListItem = ({ name, isSelected, onClick }) => {
  const classes = classNames({
    'radio-button-list__option': true,
    'radio-button-list__option--selected': isSelected,
  })
  const iconName = isSelected ? 'checkbox-selected' : 'checkbox-unselected'

  return (
    <div className={classes} onClick={onClick}>
      <div className="row">
        <div className="row__col--fixed radio-button-list__radio-button">
          <Icon name={iconName} />
        </div>

        <div className="row__col text-truncate">{name}</div>
      </div>
    </div>
  )
}

CheckboxListItem.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default CheckboxListItem
